import { DateisValid } from "../../utils/commonComponent/errorAlert";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";

export const getCustomerDetails = (cert) => [
  {
    label: "Customer Name", value: cert?.jobRegister_clientName,
  },
  {
    label: "Address of Customer", value: cert?.inward_address,
  },
  {
    label: "Principal Client", value: cert?.inward_principleClient,
  },
  {
    label: "Name of Project", value: cert?.jobRegister_projectName,
  },
  {
    label: "Discipline", value: DisciplineOptions.find((key) => key.id == cert?.inward_disciplineId)?.label || "",
  },
  {
    label: "Group", value: cert?.discipline_groupName,
  },
  {
    label: "Customer Reference", value: cert?.jobRegister_reference,
  },
  {
    label: "Source of Sample", value: cert?.inward_sampleDetails,
  },
  {
    label: "Type of Material Tested", value: cert?.materialScope_MaterialName,
  },
  {
    label: "Quantity of Samples Tested", value: cert?.inwardTests_quantity,
  },
  {
    label: "Condition of Sample", value: cert?.inward_sampleDetails,
  },
  {
    label: "Date of Sample Receipt", value: DateisValid(cert?.inward_inwardDate),
  },
  {
    label: "Period of Test", value: `${DateisValid(
      cert?.observationSheet_startTestingDate
    )} to ${DateisValid(cert?.observationSheet_endTestingDate)}`,
  },
  {
    label: "Lab. Test Results", value: "As Per Attached Annexures",
  },
];

export const summaryLable = "Summary Report";